import { FormControlLabel, Radio } from '@mui/material';
import { FieldPath, FieldValues } from 'react-hook-form';

import { RadioButtonsGroup } from '@/components/form-elements/RadioButtonsGroup';

type RadioButtonsWsaTypeProps<U extends FieldValues> = {
  label: string;
  name: FieldPath<U>;
  isLoading: boolean;
  disabled?: boolean;
};

export function RadioButtonsWsaType<U extends FieldValues>({
  label,
  name,
  isLoading,
  disabled,
}: RadioButtonsWsaTypeProps<U>) {
  return (
    <RadioButtonsGroup
      label={label}
      name={name}
      isLoading={isLoading}
      setValueAs={(value: string) => value === 'true'}
      disabled={disabled}
    >
      {[
        { value: true, label: 'SMM' },
        { value: false, label: 'Arbeitgeber' },
      ].map(({ value, label: itemLabel }) => (
        <FormControlLabel key={itemLabel} value={value} control={<Radio />} label={itemLabel} />
      ))}
    </RadioButtonsGroup>
  );
}
